import _ from 'lodash'
import * as z from 'zod'
import { idiomasDisponibles, IdiomasDisponiblesZod, type IdiomasDisponibles } from './idiomas'

export { idiomasDisponibles, IdiomasDisponiblesZod }
export type { IdiomasDisponibles }

export type MicRosetta = {
  [idiomaID in IdiomasDisponibles]: string
}
export interface ColeccionDeTraducciones extends Record<string, MicRosetta> {
  [traduccionID: string]: MicRosetta
}

export const ColeccionDeTraduccionesZod = z.record(z.string(), z.record(z.string(), z.string())).refine((coleccion) => {
  const formaZod = z.record(z.string(), z.record(z.string(), z.string()))

  const parseo = formaZod.safeParse(coleccion)

  if (!parseo.success) {
    console.error('Error al parsear ColeccionDeTraducciones', parseo.error)
    return false
  }

  const coleccionParseada = parseo.data

  const idiomasConInfo = _.uniq(_.flatten(_.map(coleccionParseada, traducciones => Object.keys(traducciones))))

  // Revisar que todas las traducciones tengan todos los idiomas
  _.forEach(coleccionParseada, (traducciones, traduccionesID) => {
    _.forEach(idiomasConInfo, (idioma) => {
      if (!traducciones[idioma]) {
        console.error(`Falta traduccion para ${traduccionesID} en ${idioma}`)
        return false
      }
    })
  })
  return true
})

export function DefinirRosetta<IdiomasDisponibles extends string[]>(idiomas: IdiomasDisponibles) {
  function RosettasATraductor<
    Traducciones extends ColeccionDeTraducciones,
  >(coleccionDeRosettas: Traducciones) {
    // Implementacion de funcion de traduccion

    function traductor<
      TraduccionID extends keyof Traducciones,
      IdiomaDisponibleID extends keyof Traducciones[TraduccionID],
    >(traduccionID: TraduccionID, idiomaID: IdiomaDisponibleID): Traducciones[TraduccionID][IdiomaDisponibleID] | string {
      try {
        // return rosettaID
        const rosetta = coleccionDeRosettas[traduccionID]
        const failID = `🪲 ${String(traduccionID)} 🪲`

        const mapa = rosetta as Record<string, string>
        if (mapa?.[idiomaID as string] != null) {
          return mapa[idiomaID as string] as Traducciones[TraduccionID][IdiomaDisponibleID] | string
        }

        // Fallback: si el idioma no existe, intentar español y loguear
        if (mapa?.['es'] != null) {
          console.warn(`[rosetta] Falta traducción para "${String(traduccionID)}" en idioma "${String(idiomaID)}". Fallback a es.`)
          return mapa['es'] as Traducciones[TraduccionID][IdiomaDisponibleID] | string
        }

        return failID
      }
      catch (e) {
        console.error('error', e, { idiomas })
        return '🪲'
      }
    }

    return traductor
  }

  // RosettasATraductor.elegirIdiomaVisible = (_idioma: IdiomasDisponibles) => { }
  return RosettasATraductor
}
